import {
  BackSide,
  Color,
  Fog,
  HemisphereLight,
  Mesh,
  type Scene,
  ShaderMaterial,
  SphereGeometry,
} from 'three';

const SKY_RADIUS = 30000;
const ZENITH = new Color(0x3f74b8); // mid blue
const HORIZON = new Color(0xcfdde8); // pale haze

const vertexShader = /* glsl */ `
  varying vec3 vWorldPosition;
  void main() {
    vec4 worldPosition = modelMatrix * vec4(position, 1.0);
    vWorldPosition = worldPosition.xyz;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

const fragmentShader = /* glsl */ `
  uniform vec3 zenithColor;
  uniform vec3 horizonColor;
  varying vec3 vWorldPosition;
  void main() {
    float h = normalize(vWorldPosition).y;
    float t = pow(max(h, 0.0), 0.55);
    gl_FragColor = vec4(mix(horizonColor, zenithColor, t), 1.0);
  }
`;

/**
 * Phase-0 gradient sky + matching fog and ambient light. Replaced by a
 * Poly Haven HDRI environment in Phase 5 (see docs/ROADMAP.md).
 */
export function addSky(scene: Scene): void {
  const sky = new Mesh(
    new SphereGeometry(SKY_RADIUS, 32, 16),
    new ShaderMaterial({
      uniforms: {
        zenithColor: { value: ZENITH },
        horizonColor: { value: HORIZON },
      },
      vertexShader,
      fragmentShader,
      side: BackSide,
      depthWrite: false,
      fog: false,
    }),
  );
  scene.add(sky);

  scene.fog = new Fog(HORIZON, 6000, 28000);
  scene.add(new HemisphereLight(0xbcd4ee, 0x46553e, 0.6));
}
